export default {
	data() {
		return {
			mt: {},
			isNeed: '需要',
			hhhhhhlll: false,
			isele: '纸质版',
			isCompany: '个人',
			tishilll: '',
			invoice_title: '',
			//开户行与账号
			invoice_open_bank: '',
			tax_no: '',
			Mail_box: '',
			Mailing_address: '',
			productArr: [],
			boughtFlag: '',
			boughtProducts: [],
			commodityList: [],
            commodityProductList: [], // 单个课程列表信息
			totalprices: 0,
			// 课程包id数组
			categoryIdList: [],
			// 课程包数组
			categoryList: [],
			//是否阅读发票须知
            checkedType: false,
            // 点击下单按钮后显示加载中
            loading: false,
            // 购买前的提示
            payTips: false,
		}
	},
	methods: {
		cleaTax_no() {

			this.tax_no = ''
			if (this.isCompany != '个人') {
				this.invoice_title = this.$store.state.name
			} else {
				this.invoice_title = ''
			}
		},


		//立即下单
		payMoney: function() {

			if (!this.boughtFlag) {
                this.loading = false;
				UIkit.modal(document.querySelector('#modal-already-bought')).show();
				return;
			}
			let mt = this.mt;

			let parseArr = '';

			if (this.isNeed == '需要') {
				// if (this.tax_no == '' && this.isCompany == '单位') {
				//     this.tishilll = '税号不能为空'
				//     UIkit.modal(mt).show();
				//     return false;
				// }
				// if (this.invoice_title == '') {
				//     this.tishilll = '发票抬头不能为空'
				//     UIkit.modal(mt).show();
				//     return false;
				// }
				// if (this.Mail_box == '' && this.Mailing_address == '') {
				//     this.tishilll = '电子邮箱/邮寄地址不能为空'
				//     UIkit.modal(mt).show();
				//     return false;
				// }
			}
			// if (this.isNeed == '不需要') {
			//     this.isele = '';
			// }
			if (this.$route.query.shopId) {
				parseArr = JSON.parse(this.$route.query.shopId);
			}
            let arr = this.$route.query.commodityList;
            
            // 单个课程订单
            if(this.$route.query.type == 'single'){
                this.$post('orders/create', {
                    pay_type: 1,
                    order_type: 2,
                    token: this.$store.state.id,
                    products: arr,
                    shop_id: this.$store.state.store.id
                }).then(res => {
                    let me = this;
                    if (res.data.status === 'success') {
                        if (this.$route.query.shopId) {
                            for (let val of parseArr) {
                                (function () {
                                    me.$post('shopping_cart/delete', { token: me.$store.state.id, id: Number.parseFloat(val) }).then(res => {
                                        me.$post('shopping_cart/search', { token: me.$store.state.id, offset: '0', length: 9999, shop_id: me.$store.state.store.id }).then(res => {
                                            me.$store.state.shopNum = res.data.result.data.length;
                                        });
                                    })
                                })(val)
                            }
                        }
                        return res.data;
                    } else {
                        return res.data;
                    }
                }).then(data => {
                    // console.log(data);
                    if (data.errorMsg) {
                        if (data.errorMsg[0] == 'The invoice email must be a valid email address.') {
                            UIkit.modal(document.querySelector('#modal-email-error')).show();
                            return;
                        }
                    }
                
                    //如果是不允许有发票的版本
                    // if (this.$store.state.store.is_invoice == '1') {
                    //     this.tishilll = '发票信息填写后，需致电客服热线确认发票信息，4008-032-321'
                    //     UIkit.modal(mt).show();
                    // }
                    this.$post('orders/get', { id: data.result, token: this.$store.state.id }).then(res => {
                        console.log('bao:', this.commodityProductList)
                        this.$router.push({
                            path: '/paycenter',
                            query: {
                                order_id: data.result,
                                commodityList: JSON.stringify(this.commodityProductList),
                                code: res.data.result.code,
                            }
                        })
                    })
                })
            }
            // 课程包订单
            else{
                // 发送请求创建订单
                this.$post('orders/create_order', {
                	token: this.$store.state.id,
                	category_ids: JSON.stringify(this.categoryIdList),
                	pay_type: 6,
                	//             invoice_title: this.invoice_title,
                	//             tax_no: this.tax_no,
                	//             invoice_type: this.isele,
                	//             invoice_email: this.Mail_box,
                	//             invoice_address: this.Mailing_address,
                	// invoice_open_bank:this.invoice_open_bank,
                	shop_id: this.$store.state.store.id
                }).then(res => {
                	if (res.data.status === 'success') {
                		// 创建订单成功，删除购物车中的对应的数据
                		// 发送请求获取当前的购物车中的对应的数据
                		this.$post('shopping_cart/search', {
                			token: this.$store.state.id,
                			category_ids: JSON.stringify(this.categoryIdList),
                			shop_id: this.$store.state.store.id,
                			offset: 0,
                			length: 999
                		}).then(res2 => {
                			// list是当前用户正在购买的课程包的购物车列表
                			let list = res2.data.result.data.map(item => item.id);
                
                			// list的长度大于0，有符合条件的购物车数据(同一个用户同一个课程包)，删除数据
                			if (list.length > 0) {
                				for (let i of list) {
                					this.$post('shopping_cart/delete', {
                						token: this.$store.state.id,
                						id: i
                					}).then(() => {
                						// 重新查询购物车
                						this.$post('shopping_cart/search', {
                							token: this.$store.state.id,
                							offset: 0,
                							length: 999,
                							shop_id: this.$store.state.store.id
                						}).then(res => {
                							this.$store.state.shopNum = res.data.result.data.length;
                						});
                					})
                				}
                			}
                		})
                        this.loading = false;
                		// 跳转到支付页面
                		this.$router.replace({
                			path: '/paycenter',
                			query: {
                				order_id: res.data.result,
                				commodityList: JSON.stringify(this.categoryList)
                			}
                		});
                	} else {
                		this.$message.error('下单失败，请稍后重试');
                	}
                })
                
            }
			
		},
		homePage: function() {
			this.$router.push({
				path: '/'
			})
		},
		//跳转商品详细页面
		commodityDetails: function(id) {
			this.$router.push({
				path: '/classdetails',
				query: {
					id: id
				}
			});
		},
		//根据传来的id查找
		getGoods: function() {
            // 单个课程
            console.log(this.$route.query.type)
            if(this.$route.query.type == 'single'){
                let arr = JSON.parse(this.$route.query.commodityList);
                this.productArr = this.$route.query.commodityList;
                for (let id of arr) {
                    this.$post('products/get', { id: id }).then(res => {
                        res.data.result.id = id;
                        this.commodityProductList.push(res.data.result);
                
                        this.totalprices += Number.parseFloat(res.data.result.price);
                    });
                }
            }
            //课程包
            else{
                this.categoryIdList = JSON.parse(this.$route.query.commodityList);
                for (let id of this.categoryIdList) {
                	((id) => {
                		this.$post('product_category/get', {
                			id: id
                		}).then(res => {
                			res.data.result.id = id;
                			this.categoryList.push(res.data.result);
                			this.totalprices += Number.parseFloat(res.data.result.price);
                		});
                	})(id);
                }
            }
			
		},
		//判断课程包是否已经购买过了
		isBought: function() {
			// this.$alert('支付功能正在修复中！', '提示', {
			//     confirmButtonText: '确定'
			// });
			// return;

			// if(this.$store.state.store.id == 107 && !this.checkedType){
			// 	this.$alert('请确认已经阅读发票须知并勾选！', '提示', {
			// 	    confirmButtonText: '确定'
			// 	});
			// 	return;
			// }

            let me = this;
            
            me.loading = true;
            
            if(this.$route.query.type == 'single'){
                let arr = JSON.parse(this.$route.query.commodityList);
                for (let i = 0; i < arr.length; i++) {
                    this.$post('users/isPay', { product_id: Number.parseFloat(arr[i]), token: this.$store.state.id }).then(res => {
                        if (res.data.result != true) {
                            this.boughtFlag = false;
                            this.payMoney();
                            return;
                        } else if (i == arr.length - 1) {
                            this.boughtFlag = true;
                            this.payMoney();
                            return;
                        }
                    })
                }
            }else{
                me.$post('orders/paid_order', {
                	token: me.$store.state.id,
                	offset: 0,
                	length: 999
                }).then(res => {
                	// list是用户state等于2的订单数组
                	let list = res.data.result.data.map(item => item.id);
                	// 发送请求，查看是否已经购买过当前的课程包
                	me.$post('category_order/search', {
                		category_ids: JSON.stringify(me.categoryIdList),
                		order_ids: JSON.stringify(list),
                		offset: 0,
                		length: 999
                	}).then(res2 => {
                
                		let list2 = res2.data.result.data;
                
                		if (list2.length === 0) {
                			// 用户没有购买过这个课程包
                			me.boughtFlag = true;
                		} else {
                			// 用户购买过该课程包
                			me.boughtFlag = false;
                		}
                		me.payMoney();
                	});
                });
            }

			
		},

		// 提示内容
		tip() {
			this.$alert('<span">请在支付前检查确认本次课程与以前学习过的历史课程是否重复</span>', '重要提示', {
				dangerouslyUseHTMLString: true
			})
            
            if(this.$store.state.store.id == 107){
                this.payTips = true
            }
		}
	},

	created() {
		this.getGoods();
		this.invoice_title = this.$store.state.name

	},
	mounted: function() {
		this.tip()

		this.mt = document.querySelector('#modal-tishilll');
		document.title = '立即下单';
	},
}
